module.exports = __webpack_public_path__ + "img/magento-support-security.29222a80.jpeg";